













import Component from 'vue-class-component';
import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import {User} from '@/User';
import moment from 'moment';

@Component
export default class Person extends Vue {
  @Prop(Object) readonly user: User | undefined;

  get reqHours(): number {
    const day = moment().day() - 1;
    return day * 8
  }

  get color(): string {
    if (!this.user) {
      return 'info';
    }

    if (this.user.hours < this.reqHours) {
      return 'error';
    } else if (this.user.hours > this.reqHours) {
      return 'info';
    } else {
      return 'success';
    }
  }
}
